<button class="close modalClose" mat-button (click)="onNoClick()" tabindex="-1">
  X
</button>
<h3 mat-dialog-title>Configure Series</h3>
<p class="fieldName">Calculated Field: {{ name }}</p>
<div mat-dialog-content [formGroup]="editForm" class="form">
  <label>Break down by:</label>
  <!-- For SELECT type of fields (single)-->
  <mat-form-field appearance="fill" style="width: 60%">
    <mat-select
      formControlName="breakDownDataPointId"
      placeholder="None"
      floatPlaceholder="never"
      required="true"
    >
      <mat-option value="0"> None </mat-option>
      <mat-option *ngFor="let item of currentDataFields" [value]="item.id">
        {{ item.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <br /><br />
</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close class="button_small cancel">
    cancel
  </button>
  <button mat-button class="button_small" (click)="onConfirmClick()">
    apply
  </button>
</div>
